import {
  UPDATE_CURRENT_TAB,
  START_FLOW_EXECUTION,
  STOP_FLOW_EXECUTION,
  SET_ACTIVE_FLEXLAYOUT_TAB
} from "redux/constants/flowDesigner";

export const updateCurrentTab = (payload) => ({
  type: UPDATE_CURRENT_TAB,
  payload
});

export const startFlowExecution = () => ({
  type: START_FLOW_EXECUTION
});
export const stopFlowExecution = () => ({
  type: STOP_FLOW_EXECUTION
});
export const setActiveFlexLayoutTab = (payload) => ({
  type: SET_ACTIVE_FLEXLAYOUT_TAB,
  payload
});
